import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useVoiceVolume = (): IGlobalStore['voice_volume'] => {
  return useSelector((store: IReducerStore) => store.global.voice_volume);
};

export const useVoiceMic = (): IGlobalStore['voice_mic'] => {
  return useSelector((store: IReducerStore) => store.global.voice_mic);
};